import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15.6 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m14.45 14.89-3.63-3.53c.8-.96 1.29-2.2 1.29-3.55 0-1.38-.51-2.65-1.35-3.62a5.531 5.531 0 0 0-4.21-1.94A5.546 5.546 0 0 0 1 7.81c0 1.42.54 2.72 1.41 3.7a5.539 5.539 0 0 0 7.7.55l3.64 3.54a.508.508 0 0 0 .71-.01c.19-.19.19-.51-.01-.7zM2 7.81c0-1.15.43-2.21 1.14-3.01.84-.95 2.06-1.55 3.42-1.55 1.26 0 2.39.51 3.22 1.34a4.55 4.55 0 0 1 1.34 3.22c0 1.3-.54 2.47-1.42 3.3-.82.78-1.92 1.25-3.14 1.25-1.24 0-2.37-.5-3.19-1.31A4.518 4.518 0 0 1 2 7.81z"
    }, null, -1)
  ])))
}
export default { render };